import { render } from "./AnimalDeleteReason.vue?vue&type=template&id=e4ff63b8"
import script from "./AnimalDeleteReason.vue?vue&type=script&lang=js"
export * from "./AnimalDeleteReason.vue?vue&type=script&lang=js"

import exportComponent from "/Users/chordarts/pasti/dev10/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__